import { scrollToId } from "@/lib/analytics";

export const LogoMark = ({ className = "h-9 w-auto" }) => (
  <img
    src="/logo-mark.png"
    alt=""
    aria-hidden="true"
    className={`${className} rounded-md shadow-sm`}
  />
);

export const Logo = ({ dark = false }) => (
  <a
    href="/"
    data-testid="logo-link"
    onClick={(e) => {
      if (window.location.pathname === "/") {
        e.preventDefault();
        scrollToId("top");
      }
    }}
    className="flex items-center gap-2.5 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-teal-600"
    aria-label="VeraChart home"
  >
    <LogoMark />
    <span
      className={`font-display text-xl tracking-tight ${dark ? "text-white" : "text-navy"}`}
      style={{ fontWeight: 800 }}
    >
      Vera<span className="text-teal-600">Chart</span>
    </span>
  </a>
);
